import { render, staticRenderFns } from "./IntegrationProfile.vue?vue&type=template&id=3faefdb2&scoped=true&"
import script from "./IntegrationProfile.vue?vue&type=script&lang=js&"
export * from "./IntegrationProfile.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationProfile.vue?vue&type=style&index=0&id=3faefdb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faefdb2",
  null
  
)

export default component.exports